import { TASK_FIELDS } from 'utils/formFields/task';
import { serviceTypes } from 'utils/constants/serviceTypes';
import API from 'services/api';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { TASK_STATUS, TASK_TYPE } from 'utils/constants/task';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';

export const filters = ({
  minDate,
  maintenanceStatusFilters,
  companyId,
  userAssignedDepartments = [],
  securityCompanyId,
}) => {
  const filterTypes = {
    RegularFilters: [
      {
        label: 'dateFrom',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'dateTo',
        field: 'dateTo',
        type: 'date-picker',
        minDate,
      },
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: maintenanceStatusFilters,
        multiple: true,
        placeholder: 'Status',
      },
      TASK_FIELDS.asyncTaskTypeFilter({
        companyId,
        category: serviceTypes.maintenance,
      }),
    ],
    AdvancedFilters: [
      {
        label: 'BusinessClient',
        field: 'businessClient',
        //   options: bizClients, // make this async
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.fetchBusinessClientList,
        dataTransform: ({ data }) => {
          return data;
        },
        fetchFilters: {
          securityCompanyId,
          archived: false,
        },
        multiple: false,
        optionLabelKey: 'name',
        required: false,
      },
      {
        label: 'site',
        field: 'site',
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.fetchSitesList,
        dataTransform: ({ data }) => {
          return data;
        },
        fetchFilters: {
          securityCompanyId,
          archived: false,
        },
        multiple: false,
        optionLabelKey: 'name',
        required: false,
      },
      TASK_FIELDS.linkAssetId({
        securityCompanyId: companyId,
        archived: false,
        useAsyncInFilters: true, // if you are using async-select in filters make sure this is set to true
      }),
      ...departmentFilter(userAssignedDepartments),
    ],
  };
  return filterTypes;
};

export const defaultValues = {
  taskType: TASK_TYPE.MAINTENANCE.id,
  status: TASK_STATUS.NEW.id,
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  siteSurfaceImages: GEOGRAPHICAL_MAP,
};
